export default {
	SET_PROPERTY: 'SET_PROPERTY',
	SCRIPT: 'SCRIPT',
	CANCEL_EVENT: 'CANCEL_EVENT',
};
